/**
 * CSV設定のヒント表示コンポーネント
 *
 * 設定のコツや使い方を表示するアコーディオン
 */

import { Text, Box, Accordion, Group } from "@mantine/core";
import { HelpCircle, Sparkles } from "lucide-react";

/**
 * CSV設定のヒント表示
 */
export function CsvConfigurationHints() {
  return (
    <Accordion variant="contained" radius="md" chevronPosition="left">
      <Accordion.Item value="hints">
        <Accordion.Control icon={<HelpCircle size={16} />}>
          <Text size="sm">設定のヒントを表示</Text>
        </Accordion.Control>
        <Accordion.Panel>
          <Text size="xs" fw={700} mb={4}>設定のコツ</Text>
          <Box component="ul" style={{ margin: 0, paddingLeft: '1.2rem', marginBottom: '1rem' }}>
            <Text component="li" size="xs">
              <strong>ヘッダー名:</strong> CSVの1行目に表示される列名です。自由に入力してください。
            </Text>
            <Text component="li" size="xs" mt={4}>
              <strong>AI読取項目:</strong> AIが抽出したデータの中から、どの値を持ってくるかを指定します。
            </Text>
            <Text component="li" size="xs" mt={4}>
              <strong>デフォルト値:</strong> AIが読み取れなかった場合に自動で入る値（例：固定の会社コードなど）を設定できます。
            </Text>
          </Box>

          <Group gap="xs" mb={4}>
            <Sparkles size={14} color="var(--mantine-color-blue-6)" />
            <Text fw={700} size="xs">AI読取項目の記述例</Text>
          </Group>
          <Text size="xs" c="dimmed" style={{ lineHeight: 1.6 }}>
            ・「伝票日付」「合計金額」「備考」: そのまま項目名を入力してください。<br />
            ・「発注元.会社名」「納品先.名称」: グループ化された情報はドットで繋いで指定します。<br />
            ・「明細[].商品名」「明細[].数量」: 明細などの繰り返し項目は <strong>[]</strong> を含めて記述します。
          </Text>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}
